import "./ziwei-table-style.css";
import { React, useState, useEffect } from "react";

//紫微命盤 — 用 HTML <table> 4×4 排 12 宮 + 中宮，避開 iOS Safari grid 1fr 不均分 bug

//每個宮格的 (row, col)，以及三方四正 SVG 線
const ZIWEI_DIRECTION = [
  { index: 0, row: 1, col: 1, lines: [{x1:"0",y1:"0",x2:"100",y2:"100"},{x1:"0",y1:"0",x2:"100",y2:"25"},{x1:"0",y1:"0",x2:"25",y2:"100"},{x1:"25",y1:"100",x2:"100",y2:"25"}] },
  { index: 1, row: 1, col: 2, lines: [{x1:"25",y1:"0",x2:"75",y2:"100"},{x1:"25",y1:"0",x2:"100",y2:"75"},{x1:"25",y1:"0",x2:"0",y2:"100"},{x1:"0",y1:"100",x2:"100",y2:"75"}] },
  { index: 2, row: 1, col: 3, lines: [{x1:"75",y1:"0",x2:"25",y2:"100"},{x1:"75",y1:"0",x2:"0",y2:"75"},{x1:"75",y1:"0",x2:"100",y2:"100"},{x1:"0",y1:"75",x2:"100",y2:"100"}] },
  { index: 3, row: 1, col: 4, lines: [{x1:"100",y1:"0",x2:"0",y2:"100"},{x1:"100",y1:"0",x2:"0",y2:"25"},{x1:"100",y1:"0",x2:"75",y2:"100"},{x1:"0",y1:"25",x2:"75",y2:"100"}] },
  { index: 4, row: 2, col: 1, lines: [{x1:"0",y1:"25",x2:"100",y2:"75"},{x1:"0",y1:"25",x2:"100",y2:"0"},{x1:"0",y1:"25",x2:"75",y2:"100"},{x1:"100",y1:"0",x2:"75",y2:"100"}] },
  { index: 5, row: 2, col: 4, lines: [{x1:"100",y1:"25",x2:"0",y2:"75"},{x1:"100",y1:"25",x2:"0",y2:"0"},{x1:"100",y1:"25",x2:"25",y2:"100"},{x1:"0",y1:"0",x2:"25",y2:"100"}] },
  { index: 6, row: 3, col: 1, lines: [{x1:"0",y1:"75",x2:"75",y2:"0"},{x1:"0",y1:"75",x2:"100",y2:"100"},{x1:"0",y1:"75",x2:"100",y2:"25"},{x1:"75",y1:"0",x2:"100",y2:"100"}] },
  { index: 7, row: 3, col: 4, lines: [{x1:"100",y1:"75",x2:"0",y2:"25"},{x1:"100",y1:"75",x2:"25",y2:"0"},{x1:"100",y1:"75",x2:"0",y2:"100"},{x1:"25",y1:"0",x2:"0",y2:"100"}] },
  { index: 8, row: 4, col: 1, lines: [{x1:"0",y1:"100",x2:"100",y2:"0"},{x1:"0",y1:"100",x2:"100",y2:"75"},{x1:"0",y1:"100",x2:"25",y2:"0"},{x1:"25",y1:"0",x2:"100",y2:"75"}] },
  { index: 9, row: 4, col: 2, lines: [{x1:"25",y1:"100",x2:"75",y2:"0"},{x1:"25",y1:"100",x2:"100",y2:"25"},{x1:"25",y1:"100",x2:"0",y2:"0"},{x1:"0",y1:"0",x2:"100",y2:"25"}] },
  { index: 10, row: 4, col: 3, lines: [{x1:"75",y1:"100",x2:"25",y2:"0"},{x1:"75",y1:"100",x2:"0",y2:"25"},{x1:"75",y1:"100",x2:"100",y2:"0"},{x1:"100",y1:"0",x2:"0",y2:"25"}] },
  { index: 11, row: 4, col: 4, lines: [{x1:"100",y1:"100",x2:"0",y2:"0"},{x1:"100",y1:"100",x2:"0",y2:"75"},{x1:"100",y1:"100",x2:"75",y2:"0"},{x1:"75",y1:"0",x2:"0",y2:"75"}] },
];

const GRID_ZHI = ["巳","午","未","申","辰","酉","卯","戌","寅","丑","子","亥"];

const EMPTY_COMBINED_PALACE = {
  zhi: "", gan: "",
  natalPalace: "", decadePalace: "", flowPalace: "",
  stars: { topLeft: [], topRight: [], center: [], bottom: [] },
  combinedMarks: [],
};

const INDIVIDUAL_LAYERS = { natal: "本命", decade: "大限", flow: "流年" };

const ZiweiBoard = ({
  ziweiData,
  natalPlate,
  selectedDecadeIndex,
  selectedYear,
  onSelectDecade,
  onSelectYear,
}) => {
  //3 層獨立顯示；「綜合」是 derived（=三層全開）
  const [layers, setLayers] = useState({ natal: true, decade: false, flow: false });
  const isCombined = layers.natal && layers.decade && layers.flow;
  const toggleCombined = (checked) => {
    setLayers({ natal: checked, decade: checked, flow: checked });
  };

  //點宮位控制中宮 SVG 焦點（跟 picker 分開）
  const [displayIndex, setDisplayIndex] = useState(null);

  useEffect(() => {
    if (ziweiData) setDisplayIndex(null);
  }, [ziweiData]);

  if (!ziweiData) {
    return <div className="ziwei"><p className="hint">紫微命盤載入中…</p></div>;
  }

  const { combined, daYunMatrix } = ziweiData;

  //建 zhi → decades 對照（"12-21" 之類，只在 natalPlate 上有），畫左下角區間用
  const decadesByZhi = {};
  (natalPlate?.palaces || []).forEach((p) => {
    decadesByZhi[p.zhi] = p.decades || "";
  });

  const palaceGrid = GRID_ZHI.map((zhi) => {
    const c = combined.palaces.find((p) => p.zhi === zhi);
    if (!c) return EMPTY_COMBINED_PALACE;
    return { ...c, decades: decadesByZhi[zhi] || "" };
  });

  const mingGridIndex = Math.max(
    0,
    palaceGrid.findIndex((p) => p.natalPalace === "命宮"),
  );

  const selectedDecade = daYunMatrix?.[selectedDecadeIndex] ?? daYunMatrix?.[0];

  const focusIndex = displayIndex ?? mingGridIndex;

  const grid = Array.from({ length: 4 }, () => Array(4).fill(null));
  ZIWEI_DIRECTION.forEach((p, idx) => {
    grid[p.row - 1][p.col - 1] = idx;
  });

  //底部分析表：對齊 picker 選中的大限
  const analysisSourcePalaces = natalPlate?.palaces ?? [];
  const analysisDecade = selectedDecade
    ? analysisSourcePalaces.find((p) => {
        if (!p.decades) return false;
        const [s] = p.decades.split("-").map(Number);
        return s === selectedDecade.startAge;
      })
    : null;
  const natalProsperity = analysisDecade?.decadeOverlay?.natal?.prosperity ?? "";
  const natalObstacle = analysisDecade?.decadeOverlay?.natal?.obstacle ?? "";
  const decadeProsperity = analysisDecade?.decadeOverlay?.decade?.prosperity ?? "";
  const decadeObstacle = analysisDecade?.decadeOverlay?.decade?.obstacle ?? "";
  const flowYears = analysisDecade?.flowOverlay ?? [];

  return (
    <div className="ziwei">
      <div className="top-info">
        <button disabled>【命局】{natalPlate?.bureau}</button>
        <button disabled>【命宮】{natalPlate?.lifePalace}</button>
        <button disabled>【身宮】{natalPlate?.bodyPalace}</button>
      </div>
      <div className="top-info">
        <button disabled>【命主】{natalPlate?.lifeOwner}</button>
        <button disabled>【身主】{natalPlate?.bodyOwner}</button>
        <button disabled>【子年斗君】{natalPlate?.ziYearDouJun}</button>
      </div>
      <div className="table-title">{natalPlate?.fourPillars}</div>

      {/* 4 個 checkbox：本命 / 大限 / 流年 個別控制；綜合 = 一鍵三勾（derived）
          放在四柱標題下方、命盤上方，靠左對齊 */}
      <div className="layer-toggles">
        {Object.keys(INDIVIDUAL_LAYERS).map((key) => (
          <label key={key} className={`layer-check layer-${key} ${layers[key] ? "on" : ""}`}>
            <input
              type="checkbox"
              checked={layers[key]}
              onChange={(e) => setLayers((l) => ({ ...l, [key]: e.target.checked }))}
            />
            <span>{INDIVIDUAL_LAYERS[key]}</span>
          </label>
        ))}
        <label className={`layer-check layer-combined ${isCombined ? "on" : ""}`}>
          <input
            type="checkbox"
            checked={isCombined}
            onChange={(e) => toggleCombined(e.target.checked)}
          />
          <span>綜合</span>
        </label>
      </div>

      <div className="ziwei-wrap">
        <table className="ziwei-table">
          <tbody>
            {grid.map((row, rowIdx) => (
              <tr key={rowIdx}>
                {rowIdx === 0 || rowIdx === 3 ? (
                  row.map((palaceIdx, colIdx) => (
                    <td
                      key={colIdx}
                      className={`cell ${focusIndex === palaceIdx ? "is-active" : ""}`}
                      onClick={() => setDisplayIndex(palaceIdx)}
                    >
                      <PalaceCell palace={palaceGrid[palaceIdx]} layers={layers} />
                    </td>
                  ))
                ) : (
                  <>
                    <td
                      className={`cell ${focusIndex === row[0] ? "is-active" : ""}`}
                      onClick={() => setDisplayIndex(row[0])}
                    >
                      <PalaceCell palace={palaceGrid[row[0]]} layers={layers} />
                    </td>
                    {rowIdx === 1 && (
                      <td colSpan={2} rowSpan={2} className="center-cell">
                        <svg className="center-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
                          {ZIWEI_DIRECTION[mingGridIndex].lines.map((line, i) => (
                            <line key={`ming-${i}`} x1={line.x1} y1={line.y1} x2={line.x2} y2={line.y2}
                              stroke="#c6c6c6" strokeWidth="0.3" strokeLinecap="round" />
                          ))}
                          {ZIWEI_DIRECTION[focusIndex].lines.map((line, i) => (
                            <line key={`active-${i}`} x1={line.x1} y1={line.y1} x2={line.x2} y2={line.y2}
                              stroke="#b98800" strokeWidth="1.2" strokeLinecap="round" />
                          ))}
                        </svg>
                      </td>
                    )}
                    <td
                      className={`cell ${focusIndex === row[3] ? "is-active" : ""}`}
                      onClick={() => setDisplayIndex(row[3])}
                    >
                      <PalaceCell palace={palaceGrid[row[3]]} layers={layers} />
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 大限 picker — 12 欄，3 行：起始年份 / 起始虛歲 / 天干+地支 直書
          外層 .picker-scroll 手機版可橫向滑動避免格子擠 */}
      <div className="picker-title">十年大限</div>
      <div className="picker-scroll">
      <table className="picker-table decade-picker">
        <tbody>
          <tr>
            {(daYunMatrix || []).map((d) => {
              const startYear = d.flows?.[0]?.year;
              const isSel = d.index === selectedDecadeIndex;
              const cls = `picker-cell ${isSel ? "selected" : ""} ${d.isCurrent ? "is-current" : ""}`;
              return (
                <td
                  key={`y-${d.index}`}
                  className={cls}
                  onClick={() => onSelectDecade?.(d.index)}
                >
                  {startYear ?? ""}
                </td>
              );
            })}
          </tr>
          <tr>
            {(daYunMatrix || []).map((d) => {
              const isSel = d.index === selectedDecadeIndex;
              const cls = `picker-cell ${isSel ? "selected" : ""} ${d.isCurrent ? "is-current" : ""}`;
              return (
                <td
                  key={`a-${d.index}`}
                  className={cls}
                  onClick={() => onSelectDecade?.(d.index)}
                >
                  {d.startAge}歲
                </td>
              );
            })}
          </tr>
          <tr>
            {(daYunMatrix || []).map((d) => {
              const isSel = d.index === selectedDecadeIndex;
              const cls = `picker-cell ${isSel ? "selected" : ""} ${d.isCurrent ? "is-current" : ""}`;
              return (
                <td
                  key={`gz-${d.index}`}
                  className={cls}
                  onClick={() => onSelectDecade?.(d.index)}
                >
                  <div className="gz">
                    <span>{d.gan}</span>
                    <span>{d.zhi}</span>
                  </div>
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      </div>

      {/* 流年 picker — 10 欄，同上格式 */}
      {/*   Row 1: 虛歲 / Row 2: 西元年 / Row 3: 天干+地支 直書 */}
      <div className="picker-title">流年</div>
      <div className="picker-scroll">
      <table className="picker-table year-picker">
        <tbody>
          <tr>
            {(selectedDecade?.flows || []).map((f) => {
              const isSel = f.year === selectedYear;
              const cls = `picker-cell ${isSel ? "selected" : ""} ${f.isCurrent ? "is-current" : ""}`;
              return (
                <td
                  key={`a-${f.year}`}
                  className={cls}
                  onClick={() => onSelectYear?.(f.year)}
                >
                  {f.age}歲
                </td>
              );
            })}
          </tr>
          <tr>
            {(selectedDecade?.flows || []).map((f) => {
              const isSel = f.year === selectedYear;
              const cls = `picker-cell ${isSel ? "selected" : ""} ${f.isCurrent ? "is-current" : ""}`;
              return (
                <td
                  key={`y-${f.year}`}
                  className={cls}
                  onClick={() => onSelectYear?.(f.year)}
                >
                  {f.year}
                </td>
              );
            })}
          </tr>
          <tr>
            {(selectedDecade?.flows || []).map((f) => {
              const isSel = f.year === selectedYear;
              const cls = `picker-cell ${isSel ? "selected" : ""} ${f.isCurrent ? "is-current" : ""}`;
              return (
                <td
                  key={`gz-${f.year}`}
                  className={cls}
                  onClick={() => onSelectYear?.(f.year)}
                >
                  <div className="gz">
                    <span>{f.yearGan}</span>
                    <span>{f.yearZhi}</span>
                  </div>
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      </div>

      {/* 暫時 comment：十年大運／流年運勢 下方兩張分析表（等回頭再啟用）
      <div className="flow-title">十年大運／流年運勢</div>

      <table className="flow-summary">
        <tbody>
          <tr>
            <td colSpan={3} className="cell header">
              {`【${analysisDecade?.decades ?? ""}歲】十年大運分析`}
            </td>
          </tr>
          <tr>
            <td className="cell"></td>
            <td className="cell">化祿</td>
            <td className="cell">化忌</td>
          </tr>
          <tr>
            <td className="cell">本命</td>
            <td className="cell label">{natalProsperity}</td>
            <td className="cell label">{natalObstacle}</td>
          </tr>
          <tr>
            <td className="cell">大限</td>
            <td className="cell label">{decadeProsperity}</td>
            <td className="cell label">{decadeObstacle}</td>
          </tr>
        </tbody>
      </table>

      <table className="flow-table">
        <thead>
          <tr>
            <th className="cell header">流年</th>
            <th className="cell header">化祿</th>
            <th className="cell header">化忌</th>
          </tr>
        </thead>
        <tbody>
          {flowYears.map((f) => (
            <tr key={f.year}>
              <td className="cell">
                <div>大限</div>
                <div>{`流年(${f.year})`}</div>
              </td>
              <td className="cell label">
                <div>{f.decade?.prosperity ?? ""}</div>
                <div>{f.flow?.prosperity ?? ""}</div>
              </td>
              <td className="cell label">
                <div>{f.decade?.obstacle ?? ""}</div>
                <div>{f.flow?.obstacle ?? ""}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      */}
    </div>
  );
};

//每宮渲染：讀 combined.palaces 的一筆，依 layers 決定顯示
//  結構：上半部左右切（左小 12神+輔星、右大 主星+四化 badge），下半 bottom-star + label-full
const PalaceCell = ({ palace, layers }) => {
  //combinedMarks: [{ star, natal, decade, flow }, ...]
  const marksByStar = (palace.combinedMarks || []).reduce((acc, m) => {
    if (m?.star) acc[m.star] = m;
    return acc;
  }, {});

  //palace 動態 class：依疊了幾個宮名 pill 擴大 padding-bottom，避免壓到 bottom-star
  const palaceClass = [
    "palace",
    layers.decade ? "has-decade" : "",
    layers.flow ? "has-flow" : "",
  ]
    .filter(Boolean)
    .join(" ");

  //每星底下永遠 render 3 slot（沒選 layer OR 沒化 → placeholder 佔位）
  //  保證 top-right 高度固定；橫排也自動對齊
  const renderBadge = (layerKey, val) => {
    const active = layers[layerKey] && !!val;
    return (
      <span
        className={`trans trans-${layerKey} ${active ? "" : "placeholder"}`}
      >
        {active ? val : "祿"}
      </span>
    );
  };

  return (
    <div className={palaceClass}>
      {/* 上半部：左右切 */}
      <div className="palace-upper">
        {/* 左：12神 + 輔星，直向堆疊 */}
        <div className="palace-upper-left">
          <div className="top-left">
            {palace.stars.topLeft.map((s, i) => <span key={i}>{s}</span>)}
          </div>
          <div className="center-star">
            {palace.stars.center.map((s, i) => <span key={i}>{s}</span>)}
          </div>
        </div>

        {/* 右：主星 + 四化 badge（每星底下 3 slot 垂直堆疊） */}
        <div className="palace-upper-right">
          {palace.stars.topRight.map((s, i) => {
            const m = marksByStar[s];
            return (
              <div key={i} className="star-slot">
                <span className="star-name">{s}</span>
                {renderBadge("natal", m?.natal)}
                {renderBadge("decade", m?.decade)}
                {renderBadge("flow", m?.flow)}
              </div>
            );
          })}
        </div>
      </div>

      {/* 下半：雜曜（跨全寬）*/}
      <div className="bottom-star">
        {palace.stars.bottom.map((s, i) => <span key={i}>{s}</span>)}
      </div>

      {/* 宮名 + 干支 */}
      <div className="label-full">
        <div className="label-info">
          {layers.flow && palace.flowPalace && (
            <p className="label-sub flow-name">{palace.flowPalace}</p>
          )}
          {layers.decade && palace.decadePalace && (
            <p className="label-sub decade-name">{palace.decadePalace}</p>
          )}
          {layers.natal && palace.natalPalace && (
            <p className="label-name natal-name">{palace.natalPalace}</p>
          )}
        </div>
        <div className="ganzhi">
          <span>{palace.gan}</span>
          <span>{palace.zhi}</span>
        </div>
      </div>

      {/* 大限區間（例 12-21）：左下角、小字、緊貼底邊 */}
      {palace.decades && (
        <div className="decade-range">{palace.decades}</div>
      )}
    </div>
  );
};

export default ZiweiBoard;
